import { render, staticRenderFns } from "./common-index.vue?vue&type=template&id=7ba22cee&"
import script from "./common-index.vue?vue&type=script&lang=js&"
export * from "./common-index.vue?vue&type=script&lang=js&"
import style0 from "./common-index.vue?vue&type=style&index=0&id=7ba22cee&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports